var _a, _b, _c;
export const isWindows = ((_a = globalThis.process) === null || _a === void 0 ? void 0 : _a.platform) === 'win32';
export const PATH = isWindows ? Object.keys((_b = globalThis.process) === null || _b === void 0 ? void 0 : _b.env).find(e => Boolean(e.match(/^PATH$/i))) || 'Path' : 'PATH';
export const PATHS_SEP = ((_c = globalThis.process) === null || _c === void 0 ? void 0 : _c.platform) === 'win32' ? ';' : ':';
//# sourceMappingURL=env.js.map